import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Select, Spin, Button, message, Space } from "antd";
import sleep from "../function/sleep";
import { Cable } from "../../api";
const { Option } = Select;


const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

export default function PermissionModal({
    visible,
    machineID,
    machineInfo,
    passwords,
    setPasswords,
    permissionID,
    setPermissionID,
    names,
    setNames,
    setEditPermission
}) {
    const { IP, port } = machineInfo;
    const [loading, setLoading] = useState(true);
    const [formPassword] = Form.useForm();
    const [formName] = Form.useForm();


    useEffect(async () => {
        if (!visible) return;
        formPassword.setFieldsValue({
            password: passwords[permissionID-1]
        });
        formName.setFieldsValue({
            name: names[permissionID - 1]
        });
        setLoading(false);
    }, [visible])

    useEffect(async () => {
        if (!visible) return;
        formPassword.setFieldsValue({
            password: passwords[permissionID-1]
        });
        formName.setFieldsValue({
            name: names[permissionID - 1]
        });
    }, [permissionID])

    useEffect(() => {
        if (visible && loading) {
            formPassword.setFieldsValue({
                password: passwords[permissionID-1]
            });
        }
    }, [passwords])


    const refreshPassword = async () => {
        let response = await Cable.InitPermissionPassword(IP, port, permissionID);
        if (response.code !== 200) {
            message.error(response.message);
            return;
        }
        for (let i = 0; i < 3; i++) {
            await sleep(10000);
            response = await Cable.GetPermissionPassword(IP, port, permissionID);
            if (response.code === 200) {
                break;
            }
        }
        if (response.code !== 200)
            alert("取得授權碼失敗！");
        return response;
    }


    const onFinishPassword = async () => {
        const { password } = formPassword.getFieldsValue();
        setLoading(true);
        let response = await Cable.UpdatePermissionPassword(IP, port, permissionID, password);
        setLoading(false);
        if (response.code === 200) {
            let newPasswords = [...passwords];
            newPasswords[permissionID - 1] = password;
            setPasswords(newPasswords);
            alert("成功更新授權碼")
        }
        else
            alert("更新授權碼失敗！");
    };

    const onFinishName = async () => {
        const { name } = formName.getFieldsValue();
        let response = await Cable.UpdatePermissionName(machineID, permissionID, name);
        if (response.code === 200) {
            let newNames = [...names];
            newNames[permissionID - 1] = name;
            setNames(newNames);
            alert("成功更新姓名");
        }
        else
            alert("更新姓名失敗！");

    }

    const updatePasswordConfirm = () => {
        Modal.confirm({
            title: "確認寫入",
            content: "確認寫入授權碼？",
            onOk: () => {
                formPassword.submit();
            }
        });
    }

    const refreshPasswordConfirm = () => {
        Modal.confirm({
            title: "確認刷新",
            content: "確認刷新授權碼？",
            onOk: async () => {
                let response = await refreshPassword();
                if (response.code === 200) {
                    let newPasswords = [...passwords];
                    newPasswords[permissionID - 1] = response.data;
                    setPasswords(newPasswords)
                    alert("授權碼刷新成功");
                }
                else alert("授權碼刷新失敗");
            }
        });
    }

    const updateNameConfirm = () => {
        Modal.confirm({
            title: "確認寫入",
            content: "確認寫入授權持有人姓名？",
            onOk: () => {
                formName.submit();
            }
        });
    }


    return (
        <div>
            <Modal
                title="編輯索道權限"
                open={visible}
                onCancel={() => setEditPermission(false)}
                onOk={() => setEditPermission(false)}
            >
                {
                    loading ? (<Spin />) : (
                        <div>
                            <Select style={{marginBottom: "5%"}} value={permissionID} onChange={(value) => setPermissionID(value)}>
                                {[...Array(5).keys()].map(i => (
                                    <Option value={i+1} key={i+1}>{"索道權限"+(i+1)}</Option>
                                ))}
                            </Select>

                            <Form form={formPassword} onFinish={onFinishPassword} {...layout}>
                                <Form.Item
                                    name="password"
                                    label={"授權碼" + (permissionID)}
                                    rules={[{ required: true, message: '請輸入授權碼' }]}
                                >
                                    <Input/>
                                </Form.Item>

                                <Form.Item {...tailLayout}>
                                    <Space>
                                        <Button type="default" style={{ background: "var(--content-background)", color: "var(--primary-text)", border: "2px solid var(--primary-border)" }} onClick={updatePasswordConfirm}>
                                        寫入授權碼
                                        </Button>
                                        <Button type="default" style={{ background: "var(--content-background)", color: "var(--primary-text)", border: "2px solid var(--primary-border)" }} onClick={refreshPasswordConfirm}>
                                        讀取授權碼
                                        </Button>
                                    </Space>
                                </Form.Item>
                            </Form>
                            <Form form={formName} onFinish={onFinishName} {...layout}>
                                <Form.Item
                                    name="name"
                                    label={"權限持有人姓名" + (permissionID)}
                                    rules={[{ required: true, message: '請輸入權限持有人姓名' }]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                                    <Button type="default" style={{ background: "var(--content-background)", color: "var(--primary-text)", border: "2px solid var(--primary-border)" }} onClick={updateNameConfirm}>
                                    寫入姓名
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                    )
                }
            </Modal >
        </div>
    );
}
